import {
  ArticleReferencesBlock,
  ContentArea,
  GridPresetMainContent,
  GridPresetSidebar,
  GridRow,
  HeroWithImage,
  MainIntro,
  MetaInfoBlock,
} from "/App.Components";
import { ContentAreaItemMargin } from "/Components/Shared/ContentAreaItem/ContentAreaItem";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { InsightArticlePageProps } from "/Models/Generated/InsightArticlePageProps";
import "./InsightArticlePage.scss";

const InsightArticlePage = ({
  pageHeader,
  mainIntro,
  mainIntroPropertyName,
  mainBody,
  metaInfoBlock,
  sidebar,
  bottomContentArea,
  articleReferences,
}: InsightArticlePageProps) => {
  return (
    <div className="insight-article-page-norad">
      {pageHeader && <HeroWithImage {...pageHeader} />}
      {(mainBody || mainIntro || sidebar) && (
        <div className="insight-article-page-norad__main-body">
          <GridRow>
            <GridPresetMainContent>
              {(mainIntro || mainIntroPropertyName) && (
                <MainIntro {...{ mainIntro, mainIntroPropertyName }} />
              )}
              {mainBody && (
                <ContentArea
                  {...mainBody}
                  contentAreaType={ContentAreaType.HalfWidth}
                />
              )}
            </GridPresetMainContent>
            <GridPresetSidebar>
              <aside>
                <ContentArea
                  {...sidebar}
                  contentAreaType={ContentAreaType.OneThird}
                  margin={ContentAreaItemMargin.SidebarInsight}
                />
              </aside>
            </GridPresetSidebar>
          </GridRow>
          {bottomContentArea && (
            <ContentArea
              {...bottomContentArea}
              contentAreaType={ContentAreaType.FullWidth}
            />
          )}
          {metaInfoBlock && (
            <div className="insight-article-page-norad__meta-info-block-wrapper">
              <GridRow>
                <GridPresetMainContent>
                  <MetaInfoBlock {...metaInfoBlock} />
                </GridPresetMainContent>
              </GridRow>
            </div>
          )}
          {articleReferences && (
            <div className="insight-article-page-norad__article-references-wrapper">
              <GridRow>
                <GridPresetMainContent>
                  <ArticleReferencesBlock {...articleReferences} />
                </GridPresetMainContent>
              </GridRow>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InsightArticlePage;
